/**
 * Formatting Utilities
 */

import { format } from 'date-fns';

/**
 * Format date to readable string
 */
export const formatDate = (date, formatStr = 'MMM dd, yyyy') => {
  if (!date) return '';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, formatStr);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

/**
 * Format date with time
 */
export const formatDateTime = (date) => {
  return formatDate(date, 'MMM dd, yyyy HH:mm');
};

/**
 * Get status badge color
 */
export const getStatusColor = (status) => {
  const colors = {
    Draft: 'gray',
    in_progress: 'blue',
    submitted: 'yellow',
    completed: 'green',
    'Needs Input': 'orange',
  };

  return colors[status] || 'gray';
};

/**
 * Get status label
 */
export const getStatusLabel = (status) => {
  const labels = {
    Draft: 'Draft',
    Verified: 'Verified',
    in_progress: 'In Progress',
    submitted: 'Submitted',
    completed: 'Completed',
    'Needs Input': 'Needs Input',
  };

  return labels[status] || status;
};

/**
 * Format user name
 */
export const formatUserName = (user) => {
  if (!user) return '';

  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }

  return user.email || '';
};

/**
 * Get user initials for avatar
 */
export const getUserInitials = (user) => {
  if (!user) return '';

  const firstName = user.firstName || user.first_name || '';
  const lastName = user.lastName || user.last_name || '';

  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }

  if (user.email) {
    return user.email[0].toUpperCase();
  }

  return '?';
};

/**
 * Truncate text
 */
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.substring(0, maxLength)}...`;
};
